import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

interface BButtonProps {
  text: string;
  href: string;
  arrow: boolean;
  rounded: boolean;
  dark: boolean;
}

const BButton: React.FC<{BButtonProps}> = ({text, href, arrow = false, rounded = false, dark = false}) => {

  return (
    <BButtonContainer href={href} rounded={rounded} dark={dark}>
      {text}
      {arrow && (
        <Arrow src="https://statics.get-base.com/icons/icon_arrow_right_black.svg" width="28" alt="Arrow" />
      )}
    </BButtonContainer>
  );
};

const BButtonContainer = styled.a`
  display: flex;
  justify-content: center;
  padding: 8px 24px;
  border: 1px solid ${p => p.theme.colors.primary};
  color: ${p => p.dark ? p.theme.colors.background : p.theme.colors.primary};
  background: ${p => p.dark ? p.theme.colors.primary : p.theme.colors.card};
  border-radius: ${p => p.rounded ? '100px' : '0'};
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.01px;
  
  ${mediaqueries.phablet`
    font-size: 22px;
  `};

  &:hover {
    color: ${p => p.dark ? p.theme.colors.background : p.theme.colors.primary};
  }
`;

const Arrow = styled.img`
  margin-left: 16px;
  
  ${mediaqueries.phablet`
    margin-left: 8px;
  `};
`;

export default BButton;
